module.exports={close:"关闭",error:"错误",info:"信息",success:"成功",warning:"警告"};